/* unplugin-vue-components disabled */import { render } from "./OrganizationListView.vue?vue&type=template&id=b4154a2c&scoped=true"
import script from "./OrganizationListView.vue?vue&type=script&lang=js"
export * from "./OrganizationListView.vue?vue&type=script&lang=js"

import "./OrganizationListView.vue?vue&type=style&index=0&id=b4154a2c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4154a2c"]])

export default __exports__